export class QuotRepayDto {
    indQuotRepayMapId: {
        portfolioId: number;
        quotationId: string;
    }
    adjustTypcode: string;
    advInstallments: number;
    collectionTypcode: string;
    intrChargeTypcode: string;
    repayTypcode: string = "";
    skippedInstallments: number = 0;
    skipTypcode: string;
    serviceTypcode: string;

    constructor() {
        this.indQuotRepayMapId = {
            portfolioId: 0,
            quotationId: '',
        }
    }
}
